<div class="bd-callout bd-callout-{{ tileDetails.class }}" *ngIf="aidaEnabled">
  <div class="aida-badge-lable aida-badge-lable-{{ tileDetails.class }}">
    <img
      class="aida-icon"
      src="./../../../../assets/img/{{ tileDetails.class }}-stars.svg"
      alt="Blue stars icon"
    />
    <span class="aida-tm">AIDA&#8482;</span> Quota Performance Health Check
  </div>
  <div class="d-flex flex-column p-3">
    <p *ngIf="tileDetails.bodyText">{{ tileDetails.bodyText }}</p>
    <p *ngIf="tileDetails.subText" class="text-secondary">
      > {{ tileDetails.subText }}
    </p>
  </div>
</div>
